"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaPlayer = void 0;
const react_1 = __importStar(require("react"));
const lib_1 = require("./lib");
const FilePlayer_1 = require("./player/FilePlayer");
exports.MediaPlayer = (0, react_1.forwardRef)((props, ref) => {
    const refX = (0, react_1.createRef)();
    (0, react_1.useImperativeHandle)(ref, () => ({
        seekTo(to) {
            if (refX.current) {
                refX.current.seekTo(to);
            }
        },
        getRawPlayer() {
            return refX.current?.getRawPlayer();
        },
        play() {
            if (refX.current) {
                refX.current.play();
            }
        },
        pause() {
            if (refX.current) {
                refX.current.pause();
            }
        },
        getDuration() {
            if (refX.current) {
                refX.current.getDuration();
            }
            return -1;
        },
        getCurrentTime() {
            if (refX.current) {
                return refX.current.getCurrentTime();
            }
            return -1;
        },
    }));
    switch ((0, lib_1.playerSelector)(props)) {
        case lib_1.PlayerType.FILE:
        default:
            return (react_1.default.createElement(FilePlayer_1.FilePlayer, { ref: refX, playerProps: props }));
    }
}); // <X = any>(props: MediaPlayerProps<X>)
exports.MediaPlayer.defaultProps = {
    className: undefined,
    controls: true,
    poster: undefined,
    preload: undefined,
    width: undefined,
    height: undefined,
    autoplay: undefined,
    loop: undefined,
    muted: undefined,
    crossorigin: undefined,
    onEnded: undefined,
    onPause: undefined,
    onPlay: undefined,
    onStart: undefined,
    onProgress: undefined,
    onDurationChange: undefined,
};
